import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useState } from 'react';
import PasswordChangeDialog from './PasswordChangeDialog';


const PasswordChangeButton = props => {
    const {userid, auth} = props;
    const [anchorEl, setAnchorEl] = useState(null);
    const [show, setShow] = useState(false);
    const [mode, setMode] = useState(1);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    }

    const openPasswordDialog = (mode) => {
        setMode(mode)
        setShow(true)
        setAnchorEl(null);
    };
  
    return (
        <>
            <PasswordChangeDialog show={show} setShow={setShow} userid={userid} mode={mode} auth={auth} />
            <Box sx={{ml: 2}}>
                <Button
                    variant='outlined' color='error'
                    id="basic-button"
                    aria-controls={open ? 'basic-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    onClick={handleClick}
                >
                    비밀번호 변경
                </Button>
                <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                        'aria-labelledby': 'basic-button',
                    }}
                >
                    <MenuItem onClick={()=>openPasswordDialog(1)}>로그인</MenuItem>
                    <MenuItem onClick={()=>openPasswordDialog(2)}>이메일</MenuItem>
                </Menu>
            </Box>
        </>
    );
}

export default PasswordChangeButton